module.exports = __webpack_public_path__ + "img/mainlogo.01f4ca82.jpg";